import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Button,
  TextField,
  MenuItem,
  ListSubheader,
  Select,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { IoMdClose } from "react-icons/io";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Input } from "../hooks/useForm/inputs";
import axios from "axios";
import { useTheme } from "../style/theme";
import { handleAxiosError } from "../utilities/function";
import { useMessage } from "./Header";
import { Submit, useForm, Form } from "../hooks/useForm";
import dayjs from "dayjs";
import { IoSearch } from "react-icons/io5";

const ApplyLeaveModal = ({ openApply, setOpenApply, isteam = false }) => {
  const [leaveTypes, setLeaveType] = useState([]);
  const [category, setCategory] = useState("");
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [leaveDates, setLeaveDates] = useState([]); // holds generated range
  const [endDate, setEndDate] = useState("");
  const [reason, setReason] = useState("");
  const [teamEmail, setTeamEmail] = useState("");
  const themeMode = useTheme();
  console.log("🚀 ~ ApplyLeaveModal ~ themeMode:", themeMode);
  const [requests, setRequests] = useState([]);
  console.log("🚀 ~ ApplyLeaveModal ~ requests:", requests);
  const [reqId, setReqId] = useState([]);
  const [isJobOpen, setIsJobOpen] = useState(false);
  const [searchJob, setSearchJob] = useState("");
  const [selectedJob, setSelectedJob] = useState("Full day");
  const dropdownJobRef = useRef(null);
  const [compensationError, setCompensationError] = useState(false);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [employLists, setEmployLists] = useState([]);
  const [emp, setemp] = useState();
  const toggleReqId = (id) => {
    setReqId((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const toggleJobDropdown = (idx, isWeekend) => {
    if (isWeekend) return;
    setOpenDropdownIndex((prev) => (prev === idx ? null : idx));
  };

  console.log(category, "requestsrequestsrequests");

  const { showSuccess, showError } = useMessage();

  const currentOrg = JSON.parse(localStorage.getItem("org"));
  const currentEmp =
    currentOrg?.type === "Member"
      ? JSON.parse(localStorage.getItem("emp"))
      : null;
  const currentOwner =
    currentOrg?.type === "Owner"
      ? JSON.parse(localStorage.getItem("org"))
      : null;

  const id = currentEmp?._id != null ? currentEmp?._id : currentOwner?.userId;

  console.log(id, "currentEmpcurrentEmpcurrentEmp");

  const fetchEmplyoees = async (search = "") => {
    try {
      const response = await axios.get(
        `/hr/employee?searchBy=firstName&search=${search}&sortBy=order&status=&page=1`
      );

      setEmployLists(response?.data?.employees);
    } catch (error) {
      console.error("Failed to fetch employees:", error);
    }
  };

  useEffect(() => {
    const fetchLeaveTypes = async () => {
      try {
        const res = await axios.get(
          `/employee/leaves/types?orgId=${currentOrg?._id}`
        );
        setLeaveType(res.data.leaveTypes || []);
      } catch (e) {
        console.warn("Leave types fetch failed", e);
      }
    };

    fetchLeaveTypes();

    if (isteam) {
      fetchEmplyoees();
    }
  }, []);

  const fetchRequests = async (id) => {
    try {
      let response = [];

      if (isteam) {
        const res = await axios.get(`/hr/compensatory/${id}`);
        const filteredRequests = res?.data?.request?.filter(
          (req) =>
            req?.balance !== undefined &&
            req?.balance !== 0 &&
            req?.isAllowable !== false
        );
        setRequests(filteredRequests);
      } else if (currentOrg?.type == "Owner") {
        response = await axios.get(
          `/hr/adminCompensatory?orgId=${currentOrg?._id}`
        );

        const filteredRequest = response?.data?.requests?.filter(
          (req) =>
            req?.balance !== undefined &&
            req?.balance !== 0 &&
            req?.isAllowable !== false
        );

        console.log("🚀 ~ fetchRequests ~ response:", filteredRequest);
        setRequests(filteredRequest);
      } else {
        const res = await axios.get(`/hr/compensatory/${currentEmp?._id}`);
        const filteredRequests = res?.data?.request?.filter(
          (req) =>
            req?.balance !== undefined &&
            req?.balance !== 0 &&
            req?.isAllowable !== false
        );
        setRequests(filteredRequests);
      }
    } catch (error) {
      console.error("Error fetching requests:", error);
    }
  };

  useEffect(() => {
    if (!isteam) {
      fetchRequests();
    }
  }, [isteam]);

  const calculateLeaveDays = () => {
    if (!startDate) return 0;

    const start = new Date(startDate);
    const end = endDate ? new Date(endDate) : start;
    let days = 0;
    let current = new Date(start);

    while (current <= end) {
      const day = current.getDay();
      if (day >= 1 && day <= 5) days++;
      current.setDate(current.getDate() + 1);
    }

    return days;
  };

  const handleSubmit = async () => {
    if (category === "compensatoryOff") {
      const workingDays = leaveDates.filter((d) => !d.isWeekend).length;
      const requiredHours = workingDays * 8;
      let totalHours = 0;

      reqId.forEach((id) => {
        const matched = requests.find((r) => r._id === id);
        if (matched?.duration === "Full Day") {
          totalHours += 8;
        } else if (matched?.duration === "Half Day") {
          totalHours += 4;
        } else {
          const [h, m] = matched?.duration?.split(":") || [0, 0];
          totalHours += parseInt(h) + parseInt(m) / 60;
        }
      });

      if (totalHours < requiredHours) {
        setCompensationError(true);
        return;
      }
    }

    if (!category || !startDate) {
      showError("Please fill all required fields.");
      return;
    }

    const formattedDates = endDate
      ? [
          {
            year: new Date(startDate).getFullYear(),
            month: new Date(startDate).getMonth() + 1,
            day: new Date(startDate).getDate(),
          },
          {
            year: new Date(endDate).getFullYear(),
            month: new Date(endDate).getMonth() + 1,
            day: new Date(endDate).getDate(),
          },
        ]
      : [
          {
            year: new Date(startDate).getFullYear(),
            month: new Date(startDate).getMonth() + 1,
            day: new Date(startDate).getDate(),
          },
        ];

    const payload = {
  leaveType: category,
  reason,
  teamEmail,
  dates: formattedDates,
  compensatoryReq: reqId,
  ...((isteam || currentOrg?.type === "Member") ? { adminId: currentEmp?.adminId }: {}),
  ...((!isteam && currentOrg?.type === "Owner") ? { status: "Approved" } : {}),
};

    try {
      if (isteam && !emp) {
        showError("Employee is required.");
        return;
      }

      let res = [];

      if (isteam) {
        res = await axios.post(`/employee/leaves?empId=${emp}`, payload);
      } else {
        res = await axios.post(`/employee/leaves?empId=${id}`, payload);
      }

      if (res.data.success) {
        showSuccess("Leave applied successfully.");
        // fetchLeaveApplication();
        setOpenApply(false);
      }
    } catch (error) {
      handleAxiosError(error, showError);
    }
  };

  const getDateRangeWithType = (start, end) => {
    const dates = [];
    let current = new Date(start);
    end = new Date(end);

    while (current <= end) {
      const day = current.getDay();
      const isWeekend = day === 0 || day === 6;
      const formatted = dayjs(current).format("YYYY-MM-DD");

      dates.push({
        date: formatted,
        type: isWeekend ? "Weekend" : "Full Day",
        isWeekend,
      });

      current.setDate(current.getDate() + 1);
    }

    return dates;
  };

  return (
    <Modal open={openApply} onClose={() => setOpenApply(false)}>
      <Box
        className="flex justify-center items-center"
        sx={{ width: "100vw", height: "100vh", overflow: "hidden" }}
      >
        <Box
          sx={{
            backgroundColor:
              themeMode?.mode === "light" ? "#ffffff" : "#141414",
            display: "flex",
            flexDirection: "column",
            height: "98vh",
            width: "100vw",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <div
            className={`flex justify-between items-center p-2 sm:p-3 border-b ${
              themeMode?.mode === "light"
                ? "border-gray-300"
                : "border-gray-700"
            }`}
          >
            <Typography
              variant="h6"
              className={`font-semibold text-[17px] ${
                themeMode?.mode === "light" ? "text-black" : "text-white"
              }`}
            >
              Apply Leave
            </Typography>
            <IconButton
              onClick={() => setOpenApply(false)}
              sx={{
                backgroundColor:
                  themeMode?.mode === "light" ? "#dcdcdc" : "#2e2e2e",
                p: "5px",
                borderRadius: "5px",
              }}
            >
              <IoMdClose
                size={18}
                color={themeMode?.mode === "light" ? "#000" : "#fff"}
              />
            </IconButton>
          </div>

          {/* Body */}
          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              height: "100%",
              backgroundColor:
                themeMode?.mode === "light" ? "#edf0f4" : "#141414",
              paddingBottom: "16px",
            }}
          >
            <div className="p-2 sm:p-4 relative h-fit">
              <form
                style={{
                  backgroundColor:
                    themeMode?.mode === "light" ? "#ffffff" : "#1a1a1a",
                }}
                className="mt-4 flex flex-col gap-y-5 p-2 sm:p-4 w-full sm:w-[70%] rounded-lg"
              >
                <h2
                  className={`text-[16px] font-semibold mb-2 ${
                    themeMode?.mode === "light" ? "text-gray-800" : "text-white"
                  }`}
                >
                  Leave
                </h2>
                <hr
                  className={
                    themeMode?.mode === "light"
                      ? "border-gray-700"
                      : "border-gray-700"
                  }
                />

                {/* Employee ID */}
                {isteam && (
                  <div className="flex items-center w-full">
                    <label
                      className={`font-medium text-[14px] w-[20%] ${
                        themeMode?.mode === "light"
                          ? "text-gray-700"
                          : "text-white"
                      }`}
                    >
                      Employee ID <span className="text-red-500">*</span>
                    </label>
                    <div className="w-[80%]">
                      <Select
                        fullWidth
                        size="small"
                        value={emp}
                        onChange={(e) => {
                          setemp(e.target.value);
                          fetchRequests(e.target.value);
                        }}
                        displayEmpty
                        sx={{
                          backgroundColor:
                            themeMode?.mode === "light" ? "#fff" : "#1e1e1e",
                          color: themeMode?.mode === "light" ? "#000" : "#fff",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor:
                              themeMode?.mode === "light" ? "#ccc" : "#555",
                          },
                        }}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 250,
                              backgroundColor:
                                themeMode?.mode === "light"
                                  ? "#ffffff"
                                  : "#141414",
                              color:
                                themeMode?.mode === "light" ? "#000" : "#fff",
                            },
                          },
                        }}
                      >
                        {employLists.map((emp) => (
                          <MenuItem key={emp?._id} value={emp?._id}>
                            {emp?.firstName} {emp?.lastName}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </div>
                )}

                {/* Leave Type */}
                <div className="flex items-center w-full">
                  <label
                    className={`font-medium text-[14px] w-[20%] ${
                      themeMode?.mode === "light"
                        ? "text-gray-700"
                        : "text-white"
                    }`}
                  >
                    Leave Type <span className="text-red-500">*</span>
                  </label>
                  <div className="w-[80%]">
                    <Select
                      fullWidth
                      size="small"
                      value={category}
                      onChange={(e) => {
                        if (
                          e.target.value === "compensatoryOff" &&
                          requests?.length === 0
                        ) {
                          showError("no compensatory request remaining");
                        } else {
                          setCategory(e.target.value);
                        }
                      }}
                      displayEmpty
                      sx={{
                        backgroundColor:
                          themeMode?.mode === "light" ? "#fff" : "#1e1e1e",
                        color: themeMode?.mode === "light" ? "#000" : "#fff",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor:
                            themeMode?.mode === "light" ? "#ccc" : "#555",
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 250,
                            backgroundColor:
                              themeMode?.mode === "dark"
                                ? "#1e1e1e"
                                : "#ffffff",
                            color:
                              themeMode?.mode === "light" ? "#000" : "#fff",
                            borderColor:
                              themeMode?.mode === "light" ? "#ccc" : "#1e1e1e",
                          },
                        },
                      }}
                    >
                      <ListSubheader
                        style={{
                          backgroundColor:
                            themeMode?.mode === "light" ? "#ffffff" : "#333333",
                          color: themeMode?.mode === "light" ? "#000" : "#fff",
                        }}
                      >
                        <TextField
                          fullWidth
                          size="small"
                          placeholder="Search..."
                          value={search}
                          onChange={(e) => {
                            setSearch(e.target.value);
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <SearchIcon fontSize="small" />
                              </InputAdornment>
                            ),
                          }}
                          sx={{
                            input: {
                              color:
                                themeMode?.mode === "light" ? "#000" : "#fff",
                              backgroundColor:
                                themeMode?.mode === "light"
                                  ? "#fff"
                                  : "#333333",
                            },
                          }}
                        />
                      </ListSubheader>

                      <MenuItem value="compensatoryOff">
                        Compensatory Off
                      </MenuItem>

                      {leaveTypes
                        .filter((leave) =>
                          leave.name
                            .toLowerCase()
                            .includes(search?.toLowerCase())
                        )
                        .map((leave) => (
                          <MenuItem key={leave._id} value={leave._id}>
                            {leave.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </div>
                </div>

                {/* Dates */}
                <div className="flex items-center w-full">
                  <label
                    className={`font-medium text-[14px] w-[20%] ${
                      themeMode?.mode === "light"
                        ? "text-gray-700"
                        : "text-white"
                    }`}
                  >
                    Date <span className="text-red-500">*</span>
                  </label>
                  <div className="flex gap-4 w-[80%]">
                    <div className="w-full">
                      <TextField
                        size="small"
                        type="date"
                        fullWidth
                        value={startDate}
                        onChange={(e) => {
                          setStartDate(e.target.value);
                          if (endDate) {
                            const range = getDateRangeWithType(
                              e.target.value,
                              endDate
                            );
                            setLeaveDates(range);
                          }
                        }}
                        sx={{
                          input: {
                            backgroundColor:
                              themeMode?.mode === "light" ? "#fff" : "#1e1e1e",
                            color:
                              themeMode?.mode === "light" ? "#000" : "#fff",
                          },
                        }}
                      />

                      {compensationError && (
                        <p className="text-xs text-red-600">
                          Sorry, you have not compensated enough to avail this
                          leave.
                        </p>
                      )}
                    </div>
                    <TextField
                      size="small"
                      type="date"
                      fullWidth
                      value={endDate}
                      onChange={(e) => {
                        setEndDate(e.target.value);
                        if (startDate) {
                          const range = getDateRangeWithType(
                            startDate,
                            e.target.value
                          );
                          setLeaveDates(range);
                        }
                      }}
                      sx={{
                        input: {
                          backgroundColor:
                            themeMode?.mode === "light" ? "#fff" : "#1e1e1e",
                          color: themeMode?.mode === "light" ? "#000" : "#fff",
                        },
                      }}
                    />
                  </div>
                </div>

                {category == "compensatoryOff" && requests?.length > 0 && (
                  <div className="flex items-start w-full ">
                    <label
                      className={`${
                        themeMode?.mode == "dark"
                          ? "text-white"
                          : "text-gray-600"
                      } font-medium w-[20%] text-[14px]`}
                    >
                      Compensated with <span className="text-red-500">*</span>
                    </label>
                    <div className="w-[80%] ">
                      <div
                        className={` items-center gap-2 grid grid-cols-2 flex-wrap border p-2 justify-between ${
                          themeMode?.mode == "dark"
                            ? "border-[#555]"
                            : "border-[#ccc]"
                        }`}
                      >
                        {requests?.map((data) => {
                          const formattedDate = dayjs(data?.workedDate).format(
                            "DD-MMMM-YYYY"
                          );
                          const isSelected = reqId?.includes(data._id);

                          return (
                            <button
                              type="button"
                              key={data._id}
                              onClick={() => toggleReqId(data._id)}
                              className={`border ${
                                themeMode?.mode == "dark"
                                  ? "border-[#555]"
                                  : "border-[#ccc]"
                              } rounded-sm p-1 flex items-center justify-between ${
                                isSelected ? " border-blue-400" : ""
                              }`}
                            >
                              <p>{formattedDate}</p>
                              <p>
                                {data?.duration == "Half Day"
                                  ? "04:00"
                                  : data?.duration == "Full Day"
                                  ? "08:00"
                                  : data?.duration}
                              </p>
                            </button>
                          );
                        })}
                      </div>
                      {leaveDates?.length > 0 && (
                        <>
                          <div
                            style={{
                              backgroundColor:
                                themeMode?.mode === "light"
                                  ? "#fff"
                                  : "#1e1e1e",
                              borderColor:
                                themeMode?.mode === "light" ? "#ccc" : "#555",
                              color:
                                themeMode?.mode === "light" ? "#000" : "#fff",
                            }}
                            className="border mt-5"
                          >
                            {leaveDates?.map((leave, idx) => (
                              <div
                                key={idx}
                                className="flex items-center justify-between border-b p-2"
                              >
                                <p>
                                  {dayjs(leave.date).format("DD-MMMM-YYYY")}
                                </p>
                                <div className="relative" ref={dropdownJobRef}>
                                  <div
                                    onClick={() =>
                                      toggleJobDropdown(idx, leave.isWeekend)
                                    }
                                  >
                                    <select
                                      className={`w-full px-2 text-[14px] py-2 text-left pointer-events-none ${
                                        themeMode?.mode === "dark"
                                          ? "bg-transparent"
                                          : "bg-white"
                                      } border rounded outline-none`}
                                    >
                                      <option>{leave.type}</option>
                                    </select>
                                  </div>
                                  {openDropdownIndex == idx && (
                                    <div
                                      className={`w-[200px] z-50 absolute left-0 mt-2  ${
                                        themeMode?.mode === "dark"
                                          ? "bg-[#141414]"
                                          : "bg-white"
                                      } border  rounded-md shadow-lg`}
                                    >
                                      <div
                                        className={`${
                                          themeMode?.mode == "dark"
                                            ? ""
                                            : "bg-[#e1e4e7]"
                                        }  p-2`}
                                      >
                                        <div
                                          className={`flex  items-center border border-[#0088ff] rounded-sm h-[30px] px-2 ${
                                            themeMode?.mode == "dark"
                                              ? ""
                                              : "bg-[#fff] "
                                          }`}
                                        >
                                          <IoSearch color="#c1c1c1" />
                                          <input
                                            type="text"
                                            // placeholder="Search"
                                            value={searchJob}
                                            onChange={(e) =>
                                              setSearchJob(e.target.value)
                                            }
                                            className="w-full px-3 py-2 border-none rounded-md outline-none bg-transparent "
                                          />
                                        </div>
                                      </div>
                                      <ul className="max-h-48 overflow-y-auto">
                                        <li
                                          className={`px-4 py-2 ${
                                            themeMode?.mode == "dark"
                                              ? ""
                                              : "bg-gray-100"
                                          } text-gray-600`}
                                        >
                                          Full day
                                        </li>
                                      </ul>
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                          <div
                            className={`flex justify-between items-center p-2 border ${
                              themeMode?.mode == "dark"
                                ? "border-[#555] text-black bg-[#777676]"
                                : "border-[#ccc]"
                            }`}
                          >
                            <p>Total</p>
                            <p>
                              {leaveDates.filter((d) => !d.isWeekend).length}{" "}
                              Day(s)
                            </p>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}

                {/* Team Email */}
                <div className="flex items-center w-full">
                  <label
                    className={`font-medium text-[14px] w-[20%] ${
                      themeMode?.mode === "light"
                        ? "text-gray-700"
                        : "text-white"
                    }`}
                  >
                    Team Email ID
                  </label>
                  <div className="w-[80%]">
                    <TextField
                      size="small"
                      fullWidth
                      value={teamEmail}
                      onChange={(e) => setTeamEmail(e.target.value)}
                      sx={{
                        input: {
                          backgroundColor:
                            themeMode?.mode === "light" ? "#fff" : "#1e1e1e",
                          color: themeMode?.mode === "light" ? "#000" : "#fff",
                        },
                      }}
                    />
                  </div>
                </div>

                {/* Reason */}
                <div className="flex items-start w-full">
                  <label
                    className={`font-medium text-[14px] w-[20%] ${
                      themeMode?.mode === "light"
                        ? "text-gray-700"
                        : "text-white"
                    }`}
                  >
                    Reason for Leave
                  </label>
                  <div className="w-[80%]">
                    <TextField
                      fullWidth
                      multiline
                      rows={3}
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                      sx={{
                        textarea: {
                          backgroundColor:
                            themeMode?.mode === "light" ? "#fff" : "#1e1e1e",
                          color: themeMode?.mode === "light" ? "#000" : "#fff",
                        },
                      }}
                    />
                  </div>
                </div>
              </form>
            </div>
          </Box>

          {/* Footer */}
          <div
            style={{
              backgroundColor:
                themeMode?.mode === "light" ? "#ffffff" : "#141414",
              borderTop:
                themeMode?.mode === "light"
                  ? "1px solid #ccc"
                  : "1px solid #444",
            }}
            className="gap-2 flex justify-start items-center p-3 h-[60px]"
          >
            <Button
              variant="outlined"
              onClick={() => {
                setOpenApply(false);
                setemp("");
              }}
              sx={{
                color: themeMode?.mode === "light" ? "#000" : "#fff",
                borderColor: themeMode?.mode === "light" ? "#ccc" : "#888",
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSubmit}
              sx={{
                backgroundColor: "#1976d2",
                color: "#fff",
                "&:hover": {
                  backgroundColor:
                    themeMode?.mode === "light" ? "#1565c0" : "#115293",
                },
              }}
            >
              Submit
            </Button>
          </div>
        </Box>
      </Box>
    </Modal>
  );
};
export default ApplyLeaveModal;
